// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1972":"cc85653d","4046":"b55703ad","4203":"cc85653d","5974":"e7832f06","7679":"cc85653d"}[chunkId] + ".chunk.css";
};